(function () {
  'use strict';

  var supportsObserver = 'IntersectionObserver' in window;
  var observer = null;

  function hydrateVideo(video) {
    if (!video || video.dataset.lazyVideoLoaded === 'true') return;

    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) return;

    video.dataset.lazyVideoLoaded = 'true';

    sources.forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.load();

    if (video.autoplay) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    if (observer) observer.unobserve(video);
  }

  function getObserver() {
    if (!supportsObserver) return null;
    if (observer) return observer;

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          hydrateVideo(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });

    return observer;
  }

  function bindVideo(video) {
    if (!video || video.dataset.lazyVideoBound === 'true') return;

    video.dataset.lazyVideoBound = 'true';

    if (!supportsObserver) {
      hydrateVideo(video);
      return;
    }

    getObserver().observe(video);
  }

  function initLazyVideos(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('video.lazy-video').forEach(bindVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initLazyVideos(document);
    }, { once: true });
  } else {
    initLazyVideos(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initLazyVideos(event.target || document);
  });
})();
